<template>
  <div class="popup-controls" ref="popupControl" tabindex="0" @blur="$emit('close')">
    <ul class="popup-controls__list">
      <li class="popup-controls__item" v-if="activeButtons.add" @click.stop="addItem">
        <div class="popup-controls__icon popup-controls__icon_add">
          <svg class="plus-sm-icon" viewBox="0 0 12 12" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M6 0L6 12" stroke="currentColor" stroke-width="2"/>
            <path d="M12 6L2.68221e-07 6" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <p class="popup-controls__text">{{ addButton }}</p>
      </li>
      <li class="popup-controls__item" v-if="activeButtons.edit" @click.stop="editItem">
        <div class="popup-controls__icon popup-controls__icon_edit">
          <svg class="edit-icon" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.09066 15.4697L3.88296 15.459L3.89599 14.0347L2.45133 14.0219L2.46222 12.8313L3.49852 11.8278L6.12702 14.4663L5.09066 15.4697ZM11.0881 5.19626C11.0875 5.26302 11.0641 5.32958 11.0074 5.38472L4.83478 11.3612C4.77785 11.4163 4.70988 11.438 4.64217 11.4374C4.49543 11.4361 4.39477 11.3351 4.39609 11.1904C4.3967 11.1236 4.42011 11.0571 4.47689 11.0019L10.6495 5.02543C10.7064 4.9703 10.7743 4.94865 10.8421 4.94925C10.9888 4.95055 11.0894 5.05161 11.0881 5.19626ZM10.4982 3.05443L1.02289 12.2287L0.980548 16.8576L5.67586 16.8993L15.1511 7.72506L10.4982 3.05443ZM18.1972 4.19117C18.2007 3.81285 18.0461 3.44425 17.7889 3.17489L15.1604 0.547567C14.8919 0.27811 14.5209 0.119021 14.1371 0.115608C13.7533 0.112196 13.3795 0.264662 13.1174 0.529402L11.227 2.34872L15.88 7.01934L17.7705 5.1889C18.0324 4.93528 18.1938 4.56949 18.1972 4.19117Z"
              fill="currentColor"/>
          </svg>
        </div>
        <p class="popup-controls__text">{{ editButton }}</p>
      </li>
      <li class="popup-controls__item" v-if="activeButtons.remove" @click.stop="removeItem">
        <div class="popup-controls__icon popup-controls__icon_delete">
          <svg class="delete-icon" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.81818 13.6173C5.81818 13.8137 5.65909 13.9665 5.45455 13.9665H4.72727C4.52273 13.9665 4.36364 13.8137 4.36364 13.6173V5.93575C4.36364 5.73935 4.52273 5.58659 4.72727 5.58659H5.45455C5.65909 5.58659 5.81818 5.73935 5.81818 5.93575V13.6173ZM8.72727 13.6173C8.72727 13.8137 8.56818 13.9665 8.36364 13.9665H7.63636C7.43182 13.9665 7.27273 13.8137 7.27273 13.6173V5.93575C7.27273 5.73935 7.43182 5.58659 7.63636 5.58659H8.36364C8.56818 5.58659 8.72727 5.73935 8.72727 5.93575V13.6173ZM11.6364 13.6173C11.6364 13.8137 11.4773 13.9665 11.2727 13.9665H10.5455C10.3409 13.9665 10.1818 13.8137 10.1818 13.6173V5.93575C10.1818 5.73935 10.3409 5.58659 10.5455 5.58659H11.2727C11.4773 5.58659 11.6364 5.73935 11.6364 5.93575V13.6173ZM5.45455 2.79329L6.01136 1.51669C6.04545 1.47304 6.13636 1.40757 6.20455 1.39666H9.80682C9.86364 1.40756 9.96591 1.47304 10 1.51669L10.5455 2.79329H5.45455ZM16 3.14246C16 2.94605 15.8409 2.79329 15.6364 2.79329H12.125L11.3295 0.971118C11.1023 0.436464 10.4205 0 9.81818 0H6.18182C5.57954 0 4.89773 0.436464 4.67045 0.971118L3.875 2.79329H0.363637C0.159091 2.79329 0 2.94605 0 3.14246V3.84079C0 4.0372 0.159091 4.18996 0.363637 4.18996H1.45455V14.5775C1.45455 15.7777 2.27273 16.7598 3.27273 16.7598H12.7273C13.7273 16.7598 14.5455 15.7341 14.5455 14.5339V4.18996H15.6364C15.8409 4.18996 16 4.0372 16 3.84079V3.14246Z"
              fill="currentColor"/>
          </svg>
        </div>
        <p class="popup-controls__text">{{ removeButton }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'app-popup-controls',
  props: {
    activeButtons: {
      type: Object,
      default: () => ({ add: false, edit: true, remove: true })
    },
    addButton: {
      type: String,
      default: 'Добавить'
    },
    editButton: {
      type: String,
      default: 'Редактировать'
    },
    removeButton: {
      type: String,
      default: 'Удалить'
    }
  },
  mounted () {
    this.$refs.popupControl.focus()
  },
  methods: {
    addItem () {
      this.$emit('add-to-this-item')
    },
    editItem () {
      this.$emit('edit-this-item')
    },
    removeItem () {
      this.$emit('remove-this-item')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.popup-controls {
  position: relative;
  z-index: 999;
  top: 0;
  left: 0;
  color: $font_color_main;
  background-color: $color_main;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  user-select: none;

  &__item {
    position: relative;
    display: flex;
    justify-self: flex-start;
    align-items: center;
    padding: 5px 10px 5px 5px;
    min-height: 50px;
    cursor: pointer;
    transition: .3s;
    border-bottom: 1px solid $border_color;

    &:hover {
      color: $color__white;

      .popup-controls__icon {
        border: 1px solid currentColor;
        color: $color__white;
      }

      &::after {
        opacity: 1;
      }
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: $color__orange;
      top: 0;
      left: 0;
      transition: .3s;
      opacity: 0;
    }
  }

  &__icon {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    @include size(30px);
    border-radius: 3px;
    color: $color__copper-pink;
    margin-right: 6px;
    transition: .3s;

    // &_add {
    //   background: $button_color_fourth;
    // }

    // &_edit {
    //   background: $button_color;
    // }

    // &_delete {
    //   background: $button_color_second;
    // }
  }

  &__text {
    position: relative;
    z-index: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: -6px;
    left: auto;
    right: 10px;
    width: 10px;
    height: 10px;
    background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
    border: 1px solid $border_color;
    border-bottom: none;
    border-right: none;
    transform: rotate(45deg);
  }
}
</style>
